/**
 * Assistant bundle entry — builds to resources/dist/assistant-dock.js
 *
 * Deliberately independent of the OCR bundle: a chat-only install publishes
 * and loads this file plus widget-runtime.js, and never ships the scan widget,
 * the workspace, or the Radix components they depend on.
 */
import { AssistantDockElement } from './elements/assistant-dock-element';

if (typeof window !== 'undefined' && !window.React) {
  // React is external in this bundle and comes from widget-runtime.js. Without
  // this the failure is a bare "React is not defined" from somewhere inside
  // the bundle, which says nothing about the missing script tag.
  console.error(
    '[assistant-dock] widget-runtime.js must be loaded before assistant-dock.js. ' +
      'If you published the package views, re-publish them (--tag=ocr-views --force) ' +
      'so the partial emits both script tags.',
  );
}

if (!customElements.get('assistant-dock')) {
  customElements.define('assistant-dock', AssistantDockElement);
}
